import {AnyAction, Middleware, MiddlewareAPI} from 'redux';
import {AppDispatch} from '../createStore';
import {RootState} from '../rootReducer';

export const timeStampMiddleware: Middleware =
  (_: MiddlewareAPI<AppDispatch, RootState>) => (next: AppDispatch) => (action: AnyAction) => {
    action.meta = {...action.meta, timeStamp: Date.now()};
    return next(action);
  };
